import React, { useEffect, useState } from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import '../../css/NotificationToast.css';

const NotificationToast = () => {
  const [visible, setVisible] = useState(false);
  const [activeNotification, setActiveNotification] = useState(null);
  const { notifications } = useNotifications();

  useEffect(() => {
    // Check for new unread notifications
    const unreadNotifications = notifications.filter(n => !n.read);
    
    if (unreadNotifications.length > 0 && !visible) {
      // Show the most recent notification
      setActiveNotification(unreadNotifications[0]);
      setVisible(true);
      
      // Hide after 5 seconds
      const timer = setTimeout(() => {
        setVisible(false);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [notifications, visible]);

  if (!visible || !activeNotification) return null;

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'interview_scheduled':
        return <i className="fas fa-calendar-alt notification-toast-icon"></i>;
      case 'interview_accepted':
        return <i className="fas fa-handshake notification-toast-icon success"></i>;
      case 'application_accepted':
        return <i className="fas fa-check-circle notification-toast-icon success"></i>;
      case 'application_rejected':
        return <i className="fas fa-times-circle notification-toast-icon danger"></i>;
      case 'new_application':
        return <i className="fas fa-file-alt notification-toast-icon"></i>;
      default:
        return <i className="fas fa-bell notification-toast-icon"></i>;
    }
  };

  const getToastClass = (type) => {
    switch (type) {
      case 'application_accepted':
        return 'success-toast';
      case 'application_rejected':
        return 'danger-toast';
      case 'interview_scheduled':
      case 'interview_accepted':
        return 'info-toast';
      default:
        return '';
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setVisible(false);
  };

  return (
    <div className={`notification-toast ${getToastClass(activeNotification.type)} ${visible ? 'show' : ''}`}>
      <div className="notification-toast-icon-container">
        {getNotificationIcon(activeNotification.type)}
      </div>
      <div className="notification-toast-content">
        <p className="notification-toast-message">{activeNotification.message}</p>
      </div>
      <button 
        className="notification-toast-close"
        onClick={handleClose}
        aria-label="Close notification"
      >
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
};

export default NotificationToast; 